import merge from "lodash/merge";

class TemplateBK{
    bkConf:any = {}
    constructor(options: any) {
    this.bkConf = merge(this.bkConf, options);
    }

    // 初始化图表 柱状图
    init(){
        let self = this
        self.showBK()
        if(self.bkConf.refresh_time>0){
          self.refresh()
        }
    }

    async showBK(){
        let self = this
        let res = await self.getDataAjax(self.bkConf.api)
        let data = self.bkConf.data(res)
        self.makeBK(data)
    }

    makeBK(data:any){
        let self = this
        let _data = data
        let _container = $(`#${self.bkConf.ele}`)
        let _domArr:any = []
        for(let i = 0;i<self.bkConf.row*self.bkConf.col;i++){
            if(self.bkConf.dataprocess){
                let _dom = self.bkConf.dataprocessFun(_data[i])
                _domArr.push(_dom)
            }else{
                let _dom = {
                    html:`<div>
                      <a href='/quote/stock/${_data[i].f13}.${_data[i].f12}.html'>
                        <p>${_data[i].f14}</p>
                        <p class='${_data[i].f4>0?'gp-asc':(_data[i].f4<0?'gp-des':'')}'>${self.dataProcess(_data[i].f3,'%')}</p>
                        <p>
                            <span>${_data[i].f128 == null ? '-' : _data[i].f128}</span>
                            <span  class='${_data[i].f136>0?'gp-asc':(_data[i].f136<0?'gp-des':'')}'>${self.dataProcess(_data[i].f136,'%')}</span>
                        </p>
                      </a>
                    </div>`
                }
                
                _domArr.push(_dom)
            }
            
        }
        _container.html('')
        for(let i =0;i<self.bkConf.row;i++){
            let _rowdom = $(`<div class='template_bk'></div>`)
            for(let j=0;j<self.bkConf.col;j++){
                let _index = i*self.bkConf.col + j
                _rowdom.append(_domArr[_index].html)
            }
            _container.append(_rowdom)
        }
    }

    // 请求数据
    async getDataAjax(url: any) {
        // Ajax数据请求
        let self = this
        // let rnd = 'callbackdata' + Math.floor(Math.random() * 10000000 + 1);
        let backdata = new Promise(function (res, rej) {
          try {
            $.ajax({
              url: url,
              type: 'GET',
              timeout: 15000,
              dataType: 'jsonp',
              success: function (data) {
                // 返回成功数据
                  res(data)
              },
              error: function (err) {
                rej([])
              }
            });
          } catch (error) {
            // 错误处理
          }
        })
        
        return backdata.then(function (v: any) {
          return v
        }).catch(function (ErrMsg: any) {
          return []
        });
    
      }

    // 数据刷新
    refresh(){
      let self = this
      let timer = setInterval(function(){
        self.showBK()
      },this.bkConf.refresh_time*1000)
    }

    dataProcess(data:any, symbol:any) {
      let self = this
      if (data == undefined || data == null || data == '-' || data == '') {
          return '-'
      } else {
          return self.numberFix(data,2) + symbol
      }
    }

    numberFix(num: number, n: number) {
      var f = parseFloat(num.toString());
      if (isNaN(f)) {
        return false;
      }
      var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
      if (n == 0) {
        return f
      } else {
        var s = f.toString();
        var rs = s.indexOf('.');
        if (rs < 0) {
          rs = s.length;
          s += '.';
        }
        while (s.length <= rs + n) {
          s += '0';
        }
        return s;
      }
    }
}

export default TemplateBK